import config from "../../public/harness_config.json";

function createEmbeddedIframe(link) {
  return new Promise((resolve) => {

    const iframe = document.createElement("iframe");
    iframe.setAttribute('src', `${link}/wv2/embedded-api.html`);
    iframe.width = '0';
    iframe.height = '0';
    iframe.setAttribute('frameBorder', '0');
    iframe.style.position = 'absolute';
    iframe.style.left = '0';
    iframe.style.bottom = '0';
    iframe.onload = () => resolve(iframe);

    document.body.appendChild(iframe);
  });
}

function loginAndOpenWebApp(charityInfo, proxyToken){
  const embeddedApiUrl = `${config.scheme}://${charityInfo.subdomain}.${config.url}`;

  createEmbeddedIframe(embeddedApiUrl).then(embeddedIframe => {
      embeddedIframe.contentWindow.postMessage({
          source: "proxy-login",
          token: proxyToken
      }, embeddedApiUrl);

      setTimeout(() => {
          const win = window.open(`${embeddedApiUrl}/wv2/account`, '_blank');
          win.focus();

          setTimeout(() => document.body.removeChild(embeddedIframe), 1000);
      }, 100);

  });
}



export {loginAndOpenWebApp};